import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { DatePicker } from 'antd';
import { stringify } from 'qs';
import SelectProvincesAll from '@/componentWebs/Common/SelectProvincesAll';
import EncodeUrl from '@/utils/encode';

moment.locale('vi');

const Index = ({ defaultValue, getIsInternational }) => {
  const [key, setKey] = useState(Math.random());
  const [text, setText] = useState('');
  const [diaDiem, setdiaDiem] = useState([]);
  const [isQuocTe, setIsQuocTe] = useState('0');

  useEffect(() => {
    if (defaultValue && defaultValue.text) {
      setText(defaultValue.text || '');
    }
    if (defaultValue && defaultValue.province && defaultValue.countries) {
      setdiaDiem([defaultValue.province], defaultValue.countries);
      setIsQuocTe(defaultValue.countries === '1' ? '0' : '1');
      //   setIsQuocTe(defaultValue.countries === "1" ? "0" : "1")
    }
    setKey(Math.random());
  }, []);

  const onSubmit = e => {
    e.preventDefault();
    if ((diaDiem && diaDiem.length === 0) || (diaDiem && diaDiem.length === 1) || !diaDiem) return;

    // const params = {
    //   countries: diaDiem[0],
    //   province: diaDiem[1],
    //   text,
    // };
    window.location.href = `/tim-kiem-dia-diem/${EncodeUrl(text)}/${diaDiem[1]}`;
    // window.location.href = `/tim-kiem-dia-diem?${stringify(params)}`;
  };

  return (
    <div className="banner-main banner-main-detail">
      <div className="banner-main__box">
        <div className="banner-main__box-nav flex-b-c">
          <div className="banner-main__nav-text flex-a-c">
            <div
              className="banner-main__nav-text flex-a-c"
              onClick={() => {
                setIsQuocTe('0');
                setKey(Math.random());
                if (getIsInternational) getIsInternational('0');
              }}
            >
              <div className="checkbox_wrapper flex-center">
                <span
                  className="checkbox_inner"
                  style={{ display: isQuocTe === '0' ? 'block' : 'none' }}
                />
              </div>
              <span>Tìm nội địa</span>
            </div>
            <div
              className="banner-main__nav-text flex-a-c"
              style={{ marginLeft: 20 }}
              onClick={() => {
                setIsQuocTe('1');
                setKey(Math.random());
                if (getIsInternational) getIsInternational('1');
              }}
            >
              <div className="checkbox_wrapper flex-center">
                <span
                  className="checkbox_inner"
                  style={{ display: isQuocTe === '1' ? 'block' : 'none' }}
                />
              </div>
              <span>Tìm quốc tế</span>
            </div>
          </div>
        </div>

        <div className="banner-main__box-filter">
          <form className="banner-main__box-form flex form-hotel">
            <div className="banner-main__box-formItem" style={{ borderRight: 'none' }}>
              <div className="banner-main__input banner-main__select select-countries">
                <SelectProvincesAll
                  label="Địa điểm"
                  placeholder="Nhập địa điểm bạn muốn đến"
                  key={key}
                  defaultValue={text}
                  isInternational={isQuocTe}
                  onChange={rec => {
                    // console.log('rec: ', rec);
                    setdiaDiem([rec.countries && rec.countries.id, rec.id]);
                    setText(`${rec.provinceName || ''}, ${rec.countries && rec.countries.countrieName || ''}`);
                  }}
                />
              </div>

              <button
                className="btn btn--filter flex-a-c hidden-m-t"
                onClick={onSubmit}
                type="button"
              >
                <span>Tìm kiếm</span>
                <img
                  src="/static/vietnamTickets/images/Icon feather-search.svg"
                  alt="search"
                  className="lazyload"
                />
              </button>
            </div>

            <button className="btn btn--filter flex-a-c hidden-pc" onClick={onSubmit} type="button">
              <span>Tìm kiếm</span>
              <img
                src="/static/vietnamTickets/images/Icon feather-search.svg"
                alt="search"
                className="lazyload"
              />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Index;
